module.exports = __webpack_public_path__ + "img/clinicimg1.f2b53f81.jpg";